{{ text | stripHtml }}
<ng-container *ngIf="secondText">
  <p class="my-0 has-text-grey-dark">
    {{ secondText | stripHtml }}
  </p>
</ng-container>
